import React from "react";
import WaveText from "../WaveText";

export default function QuizGeneratorPanel({
  showQuizGenerator, generatedQuiz, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showTrueFalseGenerator,
  showWarmUpDiscussionGenerator, showCreateDialogueGenerator, showEssentialVocabularyGenerator,
  showLeadInActivitiesGenerator, showFourOpinionsGenerator, showCommunicativeSituationsGenerator,
  showMatchingHalvesGenerator, showErrorCorrectionGenerator, showGrammarRulesGenerator,
  quizType, setQuizType, quizLevel, setQuizLevel, quizCount, setQuizCount,
  quizInput, setQuizInput, quizLoading,
  handleQuizGenerate, handleQuizInsert, handleQuizCancel,
}) {
  if (!((showQuizGenerator || generatedQuiz) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showMatchingHalvesGenerator && !showErrorCorrectionGenerator && !showGrammarRulesGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleQuizCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Generate Quiz</span>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
        <button
          onClick={() => setQuizType('text')}
          style={{
            flex: 1,
            padding: '8px 12px',
            borderRadius: 6,
            border: '1.5px solid',
            background: quizType === 'text' ? '#8a2be2' : '#fff',
            color: quizType === 'text' ? '#fff' : '#8a2be2',
            borderColor: '#8a2be2',
            fontSize: 14,
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
        >
          From Text
        </button>
        <button
          onClick={() => setQuizType('topic')}
          style={{
            flex: 1,
            padding: '8px 12px',
            borderRadius: 6,
            border: '1.5px solid',
            background: quizType === 'topic' ? '#8a2be2' : '#fff',
            color: quizType === 'topic' ? '#fff' : '#8a2be2',
            borderColor: '#8a2be2',
            fontSize: 14,
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
        >
          From Topic
        </button>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
          CEFR Level:
          <select
            value={quizLevel}
            onChange={e => setQuizLevel(e.target.value)}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              cursor: 'pointer'
            }}
          >
            <option value="A1">A1 - Beginner</option>
            <option value="A2">A2 - Elementary</option>
            <option value="B1">B1 - Intermediate</option>
            <option value="B2">B2 - Upper Intermediate</option>
            <option value="C1">C1 - Advanced</option>
            <option value="C2">C2 - Mastery</option>
          </select>
        </label>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
          Questions:
          <input
            type="number"
            min={1}
            max={20}
            value={quizCount}
            onChange={e => setQuizCount(e.target.value)}
            onBlur={e => setQuizCount(Math.max(1, Math.min(20, Number(e.target.value) || 1)))}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              width: 80
            }}
          />
        </label>
      </div>

      <textarea
        value={quizInput}
        onChange={e => setQuizInput(e.target.value)}
        placeholder={quizType === 'text' ? "Paste your text here..." : "Enter a topic (e.g., 'English Grammar', 'World History')..."}
        rows={4}
        style={{
          fontSize: 15,
          padding: '12px',
          borderRadius: 8,
          border: '1.5px solid #cfcfff',
          background: '#f7fbff',
          resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
          width: '100%',
          boxSizing: 'border-box'
        }}
      />

      <button
        onClick={handleQuizGenerate}
        disabled={quizLoading || !quizInput.trim()}
        className={quizLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15,
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          background: quizLoading || !quizInput.trim() ? '#e0e0e0' : '#8a2be2',
          color: quizLoading || !quizInput.trim() ? '#999' : '#fff',
          fontWeight: 600,
          cursor: quizLoading || !quizInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s'
        }}
      >
        {quizLoading ? <WaveText /> : 'Generate Quiz'}
      </button>

      {generatedQuiz && (
        <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
            Generated: {generatedQuiz.title}
          </div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
            {generatedQuiz.questions.length} questions ready
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={handleQuizInsert}
              className="magic-btn"
              style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
